import { Card } from '@/components/ui/card';

interface AvatarSelectionProps {
  value?: string;
  onChange: (avatarType: string) => void;
  className?: string;
}

// Avatar options with image URLs instead of emojis
const AVATAR_OPTIONS = [
  {
    id: 'professional-m',
    image: '/avatars/avatar_professional_m_1768298660961.png',
    label: 'Professional',
    description: 'Business professional',
    bgColor: 'bg-lilac-100',
  },
  {
    id: 'professional-f',
    image: '/avatars/avatar_professional_f_1768298681380.png',
    label: 'Professional',
    description: 'Business professional',
    bgColor: 'bg-lilac-100',
  },
  {
    id: 'casual-m',
    image: '/avatars/avatar_casual_m_1768298700961.png',
    label: 'Casual',
    description: 'Casual style',
    bgColor: 'bg-blue-100',
  },
  {
    id: 'casual-f',
    image: '/avatars/avatar_casual_f_1768298719676.png',
    label: 'Casual',
    description: 'Casual style',
    bgColor: 'bg-blue-100',
  },
  {
    id: 'sporty-m',
    image: '/avatars/avatar_sporty_m_1768298737097.png',
    label: 'Sporty',
    description: 'Athletic style',
    bgColor: 'bg-green-100',
  },
  {
    id: 'sporty-f',
    image: '/avatars/avatar_sporty_f_1768298757622.png',
    label: 'Sporty',
    description: 'Athletic style',
    bgColor: 'bg-green-100',
  },
];

export default function AvatarSelection({ value, onChange, className = '' }: AvatarSelectionProps) {
  const selectedAvatar = AVATAR_OPTIONS.find((a) => a.id === value);

  return (
    <div className={`space-y-4 ${className}`}>
      <div className="grid grid-cols-3 sm:grid-cols-3 gap-3">
        {AVATAR_OPTIONS.map((avatar) => (
          <Card
            key={avatar.id}
            className={`p-2 cursor-pointer transition-all hover:shadow-md ${
              value === avatar.id
                ? 'ring-2 ring-purple-500 shadow-lg'
                : 'hover:bg-slate-50 border-slate-200'
            }`}
            onClick={() => onChange(avatar.id)}
            data-testid={`avatar-option-${avatar.id}`}
          >
            <div className="text-center">
              <div
                className={`w-16 h-16 mx-auto mb-2 rounded-full overflow-hidden ${avatar.bgColor}`}
              >
                <img src={avatar.image} alt={avatar.label} className="w-full h-full object-cover" />
              </div>
              <div
                className={`text-xs font-medium ${
                  value === avatar.id ? 'text-purple-600' : 'text-slate-700'
                }`}
              >
                {avatar.label}
              </div>
            </div>
          </Card>
        ))}
      </div>

      {selectedAvatar && (
        <div className="text-center">
          <div className="inline-flex items-center space-x-3 bg-slate-50 px-4 py-3 rounded-lg">
            <div className={`w-10 h-10 rounded-full overflow-hidden ${selectedAvatar.bgColor}`}>
              <img
                src={selectedAvatar.image}
                alt={selectedAvatar.label}
                className="w-full h-full object-cover"
              />
            </div>
            <span className="text-sm text-slate-600">Selected: {selectedAvatar.description}</span>
          </div>
        </div>
      )}
    </div>
  );
}

// Export avatar options for use in other components
export { AVATAR_OPTIONS };
